module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0139.jpg?v=b8a2c41e";